import { shipmentStatuses } from '@reveni-io/reveni-ui'

import { appliesWhenValues } from '@/common/components/ConditionsEditor/constants'

export const shipmentsAppliesWhenMenuItems = [
  { value: appliesWhenValues.all, label: 'Todos los envíos coinciden' },
  { value: appliesWhenValues.atLeastOne, label: 'Al menos un envío coincide' },
  { value: appliesWhenValues.none, label: 'Ningún envío coincide' },
]

export const shipmentStatusValues = [
  shipmentStatuses.requested,
  shipmentStatuses.packed,
  shipmentStatuses.ready,
  shipmentStatuses.shipped,
  shipmentStatuses.out_for_delivery,
  shipmentStatuses.delivered,
  shipmentStatuses.cancelled,
]
